import { DocumentsTable } from './documents-table/DocumentsTable'

export function DocumentsTab() {
  return (
    <div className="grow md:pt-5">
      <DocumentsTable />
    </div>
  )
}
